import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import { removeWorkingAreaMessage } from '@app/actions/customizeActions';
import Button from '@components/buttons/Button';



const WorkingAreaMessage = ({ locKey, values }) => {
  const onCloseHandler = useCallback(() => removeWorkingAreaMessage(locKey), [removeWorkingAreaMessage]);
  return (
    <div className='qau-working-area-message'>
      <LocalizedText
            id={locKey}
            values={values}
          />
          <Button className="close-btn" onClick={onCloseHandler} />
    </div>
  )
}

WorkingAreaMessage.propTypes = {
  locKey: PropTypes.string.isRequired,
  values: PropTypes.object,
};

export default WorkingAreaMessage;